<template>
    <v-container fluid>
      <v-card>
        <v-toolbar dense flat color="secondary">
          <v-toolbar-title>Purchase Invoice Preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small text to="/purchase-invoices-report">
            <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
          </v-btn>
        </v-toolbar>
  
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-btn text @click="generateInvoice" color="primary" :loading="loader">
                <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
                Invoice
              </v-btn>
            </v-col>
          </v-row>
  
          <v-divider></v-divider>
  
          <v-row class="subtitle-2 text--primary">
            <v-col cols="12" md="4">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>Invoice#:</td>
                      <td>{{ Invoice && Invoice.DocNum}}</td>
                    </tr>
                    <tr>
                      <td>Client:</td>
                      <td>{{ Invoice && Invoice.Supplier.Name}}</td>
                    </tr>
                    <tr>
                      <td>Total Bill:</td>
                      <td>{{ Invoice && Invoice.DocTotal | currency}}</td>
                    </tr>
                    <tr>
                      <td>Total Paid:</td>
                      <td>{{ Invoice && TotalPaid | currency}}</td>
                    </tr>
                    <tr>
                      <td>Balance:</td>
                      <td>{{ Invoice && Balance | currency}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
  
            <v-col cols="12" offset-md="4" md="4">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Account</th>
                      <th class="text-left">Amount Paid</th>
                      <th class="text-left">Ref No</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in Payments" v-bind:key="index">
                      <td>{{ item.Account.Name }}</td>
                      <td>{{ item.Amount | currency}}</td>
                      <td>{{ item.PaymentRemarks }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
  
          <v-divider></v-divider>
  
          <v-row dense id="po" class="text--primary subtitle-2 mt-2">
            <v-col cols="12">
              <v-data-table
                light
                :mobile-breakpoint="0"
                :items-per-page="pageItems"
                :headers="headers"
                :items="Rows"
                item-key="id"
                hide-default-footer
              >
                <template v-slot:item.Name="{ item }">
                  <span style="width: 200px">{{ item.product.Name }}</span>
                </template>
  
                <template v-slot:item.Quantity="{ item }">
                  {{
                  item.Quantity
                  }}
                </template>
  
                <template v-slot:item.Price="{ item }">
                  <span v-if="item.Price">{{ item.Price | currency }}</span>
                </template>
  
                <template v-slot:item.DiscSum="{ item }">
                  {{
                  item.DiscSum
                  }}
                </template>
  
                <template v-slot:item.LineTotal="{ item }">
                  {{
                  item.LineTotal | currency
                  }}
                </template>
              </v-data-table>
            </v-col>
          </v-row>
  
          <!-- snackbar -->
          <snackbar ref="snackbar"></snackbar>
        </v-card-text>
      </v-card>
  
      <!-- pdf preview -->
      <pdf-preview ref="pdfPreview"></pdf-preview>
      <!-- end -->
    </v-container>
  </template>
  
  
  <script>
  import { http, host } from "@/common/index";
  export default {
    props: {
      initial: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      record: {},
      loader: false,
      pageItems: 100,
      Invoice: {},
      TotalPaid: 0,
      Balance: 0,
      OutsourcedProducts: [],
      Rows: [],
      Payments: [],
      headers: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Unit", value: "Unit" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ]
    }),
    computed: {
      storeName() {
        return localStorage.getItem("storeName");
      }
    },
    watch: {
      "$route.params.id": {
        handler: "getById",
        immediate: true
      }
    },
    methods: {
      getById(val) {
        const self = this;
        this.$store
          .dispatch("get", `/purchase-invoice/${val}`)
          .then(res => {
            if (res.ResultCode == 1200) {
                self.Invoice = res.ResponseData.Invoice;
                self.TotalPaid = res.ResponseData.TotalPaid;
                self.Balance = res.ResponseData.Balance;
                self.Rows = res.ResponseData.PurchaseRows;
                self.Payments = res.ResponseData.Payments;
            } else {
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      },
      generateReceipt() {},
      generateInvoice() {
        if (!this.Invoice || !this.Invoice.id) {
          this.$refs.snackbar.show("Invoice not loaded yet", "red");
          return;
        }
        const self = this;
        this.loader = true;
        const url = `/print-purchase-invoice-document/${this.Invoice.id}`;
        http
          .get(`${host}${url}`, { responseType: "blob" })
          .then(response => {
            const blob = new Blob([response.data], { type: "application/pdf" });
            const fileUrl = URL.createObjectURL(blob);
            self.$refs.pdfPreview.show(fileUrl);
          })
          .catch(err => {
            self.$refs.snackbar.show(err, "red");
          })
          .finally(() => {
            self.loader = false;
          });
      },
      generateDelivery() {},
      setDate(date) {
        this.record.DocDate = date;
      }
    },
    created() {}
  };
  </script>
  
  <style  scoped>
  /* .v-text-field__details {
    display: none !important;
  } */
  </style>